import { API } from 'aws-amplify';

const API_NAME = "EstimatesAPI";
const BASE_PATH = "/estimate"

export default class EstimateService {
    async getEstimates(queryStringParameters={}) {
        return API.get(API_NAME, `${BASE_PATH}`,{queryStringParameters:queryStringParameters})
            .then((response) => response)
            .catch((error) => {
                console.log(error.response);
            });
    }

    async createEstimate(data) {
        return API.post( API_NAME, BASE_PATH, { body: data } )
        .then((response) => response)
        .catch((error) => {
            console.log(error.response);
        });
    }

    async updateEstimate(data, id) {
        return API.put( API_NAME, `${BASE_PATH}/${id}`, { body: data } )
        .then((response) => response)
        .catch((error) => {
            console.log(error.response);
        });
    }

    async deleteEstimate(id) {
        return API.del( API_NAME, `${BASE_PATH}/${id}`)
        .then((response) => response)
        .catch((error) => {
            console.log(error.response);
        });
    }

    async getEstimate(id) {
        return API.get( API_NAME, `${BASE_PATH}/${id}`)
        .then((response) => response)
        .catch((error) => {
            console.log(error.response);
        });
    }    
}